import { useTranslation } from 'react-i18next'
import Box from '@mui/material/Box'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import Typography from '@mui/material/Typography'
import { RegisterMethod, registerMethods } from 'pages/Login/RegisterAccount/types'
import { fontFamilies } from 'theme/styles.utils'

type Props = {
  onSuccess: (method: RegisterMethod) => void
  disabled?: boolean
  method?: RegisterMethod | null
  disabledCodes?: boolean
  disabledEmail?: boolean
}

export const ChooseMethod = ({ onSuccess, disabled, method, disabledEmail, disabledCodes }: Props) => {
  const { t } = useTranslation()

  return (
    <Box display="grid" gap={2} justifyContent="center">
      <ToggleButtonGroup
        color="primary"
        exclusive
        value={method}
        onChange={(e, newMethod: RegisterMethod) => onSuccess(newMethod as RegisterMethod)}
        disabled={disabled}
      >
        {!disabledEmail && (
          <ToggleButton value={registerMethods.domain} sx={{ borderRadius: '16px' }}>
            <Typography fontFamily={fontFamilies.default} textTransform="none">
              {t('auth.register_account.email_verification')}
            </Typography>
          </ToggleButton>
        )}
        {!disabledCodes && (
          <ToggleButton value={registerMethods.code} sx={{ borderRadius: '16px' }}>
            <Typography fontFamily={fontFamilies.default} textTransform="none">
              {t('auth.register_account.registration_code')}
            </Typography>
          </ToggleButton>
        )}
      </ToggleButtonGroup>
    </Box>
  )
}
